import { Component, OnInit } from '@angular/core';
import { CodigosObrigacoes} from '../model/codigos-obrigacoes.model';
import { CrudService } from 'app/shared/services/crud.service';
import { DataTableBasicComponent } from 'app/shared/components/data-table/data-table-basic.component';
import { Message, MessageService } from 'primeng/api';
import { SelectItem } from 'app/shared/common/select-item.interface';
import { Subscription } from 'rxjs';
import { HttpService } from 'app/shared/services/http.service';
import { DblinkedSessionService } from 'app/shared/services/dblinked-session.service';
import { SessionService } from 'app/shared/services/session.service';
import { UtilService } from 'app/shared/services/util.service';
import { ConfigService } from 'app/shared/services/config.service';
import { Empresa } from 'app/cadastro/model/empresa.model';
import { Toolbar } from 'app/shared/model/toolbar.model';
import { ToolbarService } from 'app/shared/services/toolbar.service';

@Component({
  selector: 'app-codigos-obrigacoes',
  templateUrl: './codigos-obrigacoes.component.html',
  styleUrls: ['./codigos-obrigacoes.component.scss'],
  providers: [CrudService]
})
export class CodigosObrigacoesComponent extends DataTableBasicComponent implements OnInit {
  public codigosObrigacoes: CodigosObrigacoes = new CodigosObrigacoes();
  public registroObri: Array<CodigosObrigacoes> = new Array();

  ids: Array<any> = new Array();

  //Boolean
  ctrlSave: boolean;
  editarConta: boolean;
  novaConta: boolean;

  //Any
  codObri: any;
  tipoObri: any;

  //Strings
  descricaoObri: string;
  
  //Select
  opcoesObri: SelectItem[]
 
  msgs: Message[];

  title = 'CÓDIGO DE OBRIGAÇÃO';
  subtitle = "CÓDIGO DE OBRIGAÇÃO";
  
  private sessionSubscription: Subscription;
  private beforeSaveSubscription: Subscription;
  private beforeViewSubscription: Subscription;
  private beforeEditSubscription: Subscription;

  constructor(private crudService: CrudService,
    private httpService: HttpService,
    private sessionService: SessionService,
    private toolbarService: ToolbarService,
    private dblinkedSessionService: DblinkedSessionService,
    private messageService: MessageService,
    private utilService: UtilService,
    private configService: ConfigService,
    ) {
    super(crudService);
  }

  public toolbarMain = new Toolbar()

  toolbarMainIni = [
    { icon: 'navigate_before', text: 'Voltar', tooltip: 'Voltar', visible: false, disabled: false, color: 'default', onClick: () => this.carregar() },
    { icon: 'edit', text: 'Editar', tooltip: 'Editar', visible: false, disabled: false, color: 'default', onClick: () => this.loadEditarRegistro() },
    { icon: 'delete', text: 'Remover', tooltip: 'Remover', visible: false, disabled: false, color: 'default', onClick: () => this.excluirRegistro() },
    { icon: 'add', text: 'Novo', tooltip: 'Novo', visible: false, disabled: false, color: 'default', onClick: () => this.criarNovo() },
    { icon: 'save', text: 'Salvar', tooltip: 'Salvar Novo Registro', visible: false, disabled: false, color: 'default', onClick: () => this.salvarNovoRegistro() },
    { icon: 'save', text: 'Salvar', tooltip: 'Salvar Alteração de Registro', visible: false, disabled: false, color: 'default', onClick: () => this.salvarAlteracaoRegistro() },
  ]


  ngOnInit() {
    // TODO: REVIEW (IMPORTANT!)
    this.toolbarMain.setAll(this.toolbarMainIni)
    this.toolbarService.hidden = true
    this.sessionSubscription = this.sessionService.initSubscribe(
      this.dblinkedSessionService.sessionChanged,
      () => this.carregar()
    );
  }

  list: Array<number> = new Array();

// SELECIONAR CHECKBOX
  selectCheckboxContainer(data){
    setTimeout(() => {
      document.getElementById('checkboxContainer'+data.id).click();
    },100);
  };

 
  carregar() {
    this.title = 'CÓDIGO DE OBRIGAÇÃO';
    this.subtitle = 'CÓDIGO DE OBRIGAÇÃO';
    this.novaConta = false;
    this.editarConta = false;
    this.ids = new Array();
    this.limpaCamposForm();
    this.loadRegistros();
    this.voltar = false;
    this.editar = false;
    this.excluir = false;
    this.salvarAlt = false;
    this.novo = true
    this.salvar = false;

    this.toolbarMain.setVisible('btn1', false)
    this.toolbarMain.setVisible('btn2', false)
    this.toolbarMain.setVisible('btn3', false)
    this.toolbarMain.setVisible('btn4', true)
    this.toolbarMain.setVisible('btn5', false)
    this.toolbarMain.setVisible('btn6', false)
  }

  loadItems() {
    this.opcoesObri = [];
    this.opcoesObri.push({label: 'Selecione', value: null });
    this.httpService.get(`tipoarquivo?$select=id,nome&$orderby=nome`)
      .subscribe(ref => {
        ref.value.forEach(element => {
          this.opcoesObri.push({
            label: element.nome,
            value: element.id
          });
        });
      }, error => this.httpService.handleError(error, () => this.httpService.done()));
  }

  criarNovo() {
    this.loadItems
    this.novaConta = true;
    this.title = 'CADASTRAR CÓDIGO DE OBRIGAÇÃO';
    this.voltar = true;
    this.salvar = true;
    this.novo = false;

    this.toolbarMain.setVisible('btn1', true)
    this.toolbarMain.setVisible('btn2', false)
    this.toolbarMain.setVisible('btn3', false)
    this.toolbarMain.setVisible('btn4', false)
    this.toolbarMain.setVisible('btn5', true)
    this.toolbarMain.setVisible('btn6', false)
  }

  loadRegistros() {
    this.loadItems();
    this.httpService
      .get(`/codigosobrigacoes?$select=cod,descricao,tipoArquivo/nome&$count=true&$skip=0&$orderby=cod`)
      .subscribe(
        (retorno) => {
          this.registroObri = new Array();
          retorno.value.forEach(item => {
            this.registroObri.push({
              ...item,
            });
          })
        },
        error => this.httpService.handleError(error, () => this.carregar()),
        () => this.httpService.done()
      );
  }

  loadEditarRegistro() {
    this.title = 'EDITAR CÓDIGO DE OBRIGAÇÃO';
    this.editarConta = true;
    this.voltar = true
    this.salvar = false;
    this.salvarAlt = true;
    this.novo = false;
    this.excluir = false;
    this.editar = false;

    this.toolbarMain.setVisible('btn1', true)
    this.toolbarMain.setVisible('btn2', false)
    this.toolbarMain.setVisible('btn3', true)
    this.toolbarMain.setVisible('btn4', false)
    this.toolbarMain.setVisible('btn5', false)
    this.toolbarMain.setVisible('btn6', true)

    this.limpaCamposForm();
   
    this.httpService.get(`/codigosobrigacoes(${this.ids[0]})?$select=cod,descricao,tipoArquivo/id,tipoArquivo/nome&$count=true`)
      .subscribe(plano => {
        this.codObri = plano.value.cod;
        this.descricaoObri = plano.value.descricao;
        this.tipoObri = plano.value.tipoArquivo.id;
     
      },
        error => this.httpService.handleError(error, () => this.carregar()),
        () => this.httpService.done());
  }

  salvarNovoRegistro() {
    if (this.validacao()) {
      return;
    }

    const jsonData = {
      cod: this.codObri,
      descricao: this.descricaoObri,
      tipoArquivo: {id: this.tipoObri}
    };
 
    this.httpService.wait();
    this.httpService.post('/codigosobrigacoes', jsonData)
      .subscribe(result => {

        if (!(result === null || result === undefined)) {
          this.messageService.add({
            severity: 'success', key: 'messageLinnks', summary: 'Sucesso  ', detail: 'Projeto cadastrado com sucesso!'
          });
          this.carregar();
        } else {
          this.messageService.add({
            severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Falha no cadastro. Tente novamente'
          });
          this.carregar();
          return;
        }
      }, error => this.httpService.handleError(error, () => this.salvarNovoRegistro()),
        () => this.httpService.done());
  }

  salvarAlteracaoRegistro() {
    if (this.validacao()) {
      return;
    }

    const listasEnviar = {
      id: this.ids[0],
      cod: this.codObri,
      descricao: this.descricaoObri,
      tipoArquivo: {id: this.tipoObri}
    };
   
    let key = this.ids[0];

    this.httpService.wait();
    this.httpService.patch('/codigosobrigacoes', key, listasEnviar, null)
      .subscribe(result => {
        if (result === null) {
          this.messageService.add({
            severity: 'success', key: 'messageLinnks', summary: 'Sucesso  ', detail: 'Projeto alterado com sucesso!'
          });
          this.carregar();
        } else {
          this.messageService.add({
            severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Falha na alteração do projeto!'
          });
          this.carregar();
          return;
        }
      },
        error => this.httpService.handleError(error, () => this.salvarAlteracaoRegistro()),
        () => this.httpService.done());
  }

  excluirRegistro() {
    if (confirm('Deseja deletar os registros selecionados? ')) {
      const listasEnviar = {
        idsContaContabil: this.ids,
      };
      this.httpService.wait();
      this.httpService.delete('/codigosobrigacoes', this.ids)
        .subscribe(result => {
          if (result === null) {
            this.messageService.add({
              severity: 'success', key: 'messageLinnks',
              summary: '',
              detail: 'Projeto excluído com sucesso!'
            });
            this.carregar();
            this.excluir = false;
            this.ids = [];
          } else {
            this.messageService.add({
              severity: 'warn', key: 'messageLinnks',
              summary: '',
              detail: 'Falha na exclusão. Tente novamente!'
            });
          }
        },
          error => this.httpService.handleError(error, () => this.carregar()),
          () => this.httpService.done());
    }
  }

  selectCheckbox(event: any) {
    this.ids.push(event.data.id);
    event.selected = false;
    this.changeToolbar()
  }

  unselectCheckbox(event: any) {
    const index = this.ids.findIndex(c => c === event.data.id);
    this.ids.splice(index, 1);
    event.selected = true;
    this.changeToolbarUn()
  }

  // TOOLBAR
  excluir : boolean = false
  editar : boolean = false
  voltar : boolean = false
  salvar : boolean = false
  novo : boolean = false
  salvarAlt : boolean = false;

  changeToolbar() {
    this.toolbarMain.setVisible('btn2', true)
    this.toolbarMain.setVisible('btn3', true)
  }

  changeToolbarUn(){
    this.toolbarMain.setVisible('btn2', false)
    this.toolbarMain.setVisible('btn3', false)
  }


  validacao(): boolean {
    if ((this.codObri === null || this.codObri === undefined) || this.codObri.trim().length < 1) {
      this.messageService.add({ severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Código é Obrigatório' });
      return true;
    }
    if ((this.descricaoObri === null || this.descricaoObri === undefined) || this.descricaoObri.trim().length < 1) {
      this.messageService.add({ severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Descrição é Obrigatória' });
      return true;
    } 
    if ((this.tipoObri === null || this.tipoObri === undefined) || this.tipoObri.length < 1) {
      this.messageService.add({ severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Tipo Arquivo é Obrigatório' });
      return true;
    } 
    return false;
  }

  private limpaCamposForm() {
    this.codObri = '';
    this.descricaoObri = '';
    this.tipoObri = '';
  }

  ngOnDestroy() {
    // TODO: REVIEW (IMPORTANT!)
    this.sessionSubscription.remove(this.sessionSubscription);
    this.sessionService.destroySubscribe(this.sessionSubscription);
  }
  get hasEmpresaSelected(): boolean {
    return this.dblinkedSessionService.hasEmpresaSelected;
  }
  get loading(): boolean {
    return this.httpService.loading;
  }
  get rowsPerPage() {
    return this.configService.applicationConfig.rowsPerPage;
  }
  get rows() {
    return this.configService.applicationConfig.rows;
  }
  get pageLinks() {
    return this.configService.applicationConfig.pageLinks;
  }
  get empresa(): Empresa {
    return this.dblinkedSessionService.empresa && this.dblinkedSessionService.empresa.id ? this.dblinkedSessionService.empresa : null;
  }

}


